import { Flex } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import React from "react";
import * as AF from "src/types/formTemplate";
import * as RD from "src/types/remoteData";
import { z } from "zod";
// eslint-disable-next-line no-restricted-imports
import { useEditFormTemplateContext } from "../../../context";
import { QuestionVisibility } from "../../QuestionVisibility";
import * as ConfigureDateOfBirth from "../QuestionConfiguration/ConfigureDateOfBirth";
import { ConfigureQuestion } from "../QuestionConfiguration/ConfigureQuestion";
import {
  ConfigureQuestionMenu,
  ConfigureQuestionMenuTabs,
} from "../QuestionConfiguration/ConfigureQuestionMenu";
import { SchoolItem } from "../types";
import { QuestionLink } from "./QuestionLink";

export const FormikSchema = ConfigureDateOfBirth.FormikSchema;
export const toFormValue = ConfigureDateOfBirth.toFormValue;

export type FormikType = z.infer<typeof FormikSchema>;

export type GradeQuestionFormProps = {
  questionId: uuid;
  otherQuestions: readonly AF.V2.Question[];
  schools: RD.RemoteData<unknown, SchoolItem[]>;
  sectionType: AF.V2.SectionType;
};
export function GradeQuestionForm({
  questionId,
  otherQuestions,
  schools,
  sectionType,
}: GradeQuestionFormProps) {
  const [configureQuestionTab, setConfigureQuestionTab] =
    React.useState<ConfigureQuestionMenuTabs>(
      ConfigureQuestionMenuTabs.ConfigureQuestion
    );

  const formik = useFormikContext<FormikType>();
  const { grades } = useEditFormTemplateContext();

  const handleConfigureMenuChange = (newTab: ConfigureQuestionMenuTabs) => {
    setConfigureQuestionTab(newTab);
  };

  return (
    <>
      <Flex direction="row" gap="4">
        <ConfigureQuestionMenu
          activeTab={configureQuestionTab}
          onMenuChange={handleConfigureMenuChange}
          items={[
            { type: "Separator", label: "Limit available options" },
            {
              type: ConfigureQuestionMenuTabs.DateOfBirth,
              label: "Date of birth",
              status:
                formik.values.birthdateFilter.type === "on" ? "on" : "off",
            },
          ]}
        />
        {configureQuestionTab ===
          ConfigureQuestionMenuTabs.ConfigureQuestion && (
          <ConfigureQuestion questionId={questionId} />
        )}
        {configureQuestionTab === ConfigureQuestionMenuTabs.DateOfBirth && (
          <ConfigureDateOfBirth.ConfigureDateOfBirth
            questionId={questionId}
            gradesConfig={grades}
          />
        )}
      </Flex>
      {configureQuestionTab === ConfigureQuestionMenuTabs.ConfigureQuestion && (
        <Flex direction="column" flexGrow="1" gap="3">
          <QuestionLink questionId={questionId} />
          <QuestionVisibility
            sectionType={sectionType}
            otherQuestions={otherQuestions}
            schools={schools}
          />
        </Flex>
      )}
    </>
  );
}
